import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Users, Loader2, ArrowRight, CheckCircle2 } from 'lucide-react';
import AccessGate from '../components/AccessGate';
import GroupSiteActions from '../components/GroupSiteActions';
import { useAuth } from '../context/AuthContext';

const money = (c) => `$${((c || 0) / 100).toFixed(2)}`;

export default function Subgroups() {
  const { getSubgroups } = useAuth();
  const [groups, setGroups] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => { getSubgroups().then((g) => setGroups(Array.isArray(g) ? g : [])).catch(() => setGroups([])).finally(() => setLoading(false)); /* eslint-disable-next-line react-hooks/exhaustive-deps */ }, []);

  return (
    <AccessGate pageKey="subgroups">
      <div className="max-w-5xl mx-auto px-4 py-10 fade-in" data-testid="subgroups-page">
        <div className="flex items-center gap-2 mb-1">
          <Users style={{ color: 'var(--maroon)' }} />
          <h1 className="font-title text-3xl md:text-4xl" style={{ color: 'var(--maroon)' }}>Groups</h1>
        </div>
        <div className="h-1 w-20 mb-6" style={{ background: 'var(--gold)' }} />
        <p className="text-[15px] mb-6" style={{ color: 'var(--olive)' }}>
          Sub-groups within the association — each with its own pages, members and activities. You can belong to more than one.
        </p>

        <div className="mb-8"><GroupSiteActions /></div>

        {loading ? (
          <div className="flex items-center gap-2" style={{ color: 'var(--olive)' }}><Loader2 className="animate-spin" size={16} /> Loading…</div>
        ) : groups.length === 0 ? (
          <p className="text-sm" style={{ color: 'var(--olive)' }} data-testid="subgroups-empty">No groups have been set up yet.</p>
        ) : (
          <div className="grid sm:grid-cols-2 gap-5">
            {groups.map((g) => (
              <Link to={`/g/${g.slug}`} key={g.id} data-testid={`subgroup-card-${g.slug}`}
                className="block bg-white rounded-lg border shadow-sm p-5 hover:shadow-md transition-shadow" style={{ borderColor: 'rgba(0,0,0,0.08)' }}>
                <div className="flex items-start justify-between">
                  <div className="flex items-center gap-2">
                    {g.favicon_url && <img src={g.favicon_url} alt="" className="w-5 h-5 rounded" data-testid={`subgroup-favicon-${g.slug}`} />}
                    <h3 className="font-title text-xl" style={{ color: 'var(--navy)' }}>{g.name}</h3>
                  </div>
                  {g.my_membership && g.my_membership.is_member && (
                    <span className="inline-flex items-center gap-1 text-xs font-title px-2 py-0.5 rounded" style={{ background: '#1f7a3f', color: '#fff' }}>
                      <CheckCircle2 size={12} /> Member
                    </span>
                  )}
                </div>
                {g.tagline && <p className="text-sm mt-1" style={{ color: 'var(--olive)' }}>{g.tagline}</p>}
                <div className="flex items-center justify-between mt-4">
                  <span className="text-sm" style={{ color: 'var(--olive)' }}>
                    {g.member_count} member{g.member_count === 1 ? '' : 's'} · {g.join_fee_cents > 0 ? `${money(g.join_fee_cents)}/yr` : 'Free to join'}
                  </span>
                  <span className="inline-flex items-center gap-1 text-sm font-title" style={{ color: 'var(--maroon)' }}>View <ArrowRight size={15} /></span>
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </AccessGate>
  );
}
